/* Luv Secret : Cart cross-sell "Complete your ritual" handler */
(function () {
  'use strict';

  function $$(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }

  function findCartItemsEl() {
    return document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
  }

  function isCartPage() {
    return window.location.pathname === '/cart' || window.location.pathname.match(/^\/[a-z]{2}-[a-z]{2}\/cart$/i);
  }

  // After an empty -> add operation, the cart-items custom element may have been
  // removed from the DOM (Dawn re-renders empty cart as a different layout).
  // In that case we must force a full re-render via the Section Rendering API
  // OR fall back to a page reload if we cannot rebuild the section in place.
  function forceFullCartRerender() {
    // Determine which sections to refresh
    var sectionsToFetch = [];
    var drawer = document.getElementById('CartDrawer');
    var cartPageMain = document.getElementById('main-cart-items');
    var cartPageFooter = document.getElementById('main-cart-footer');
    if (drawer) sectionsToFetch.push('cart-drawer');
    if (cartPageMain) sectionsToFetch.push('main-cart-items');
    if (cartPageFooter) sectionsToFetch.push('main-cart-footer');

    if (sectionsToFetch.length === 0) {
      // Nothing to swap. Hard reload guarantees correctness.
      window.location.reload();
      return;
    }

    // Cart-page sections must be requested from /cart (the route that renders them).
    // Drawer renders from the current page. We split the request to be safe.
    var cartPageSections = sectionsToFetch.filter(function (s) {
      return s === 'main-cart-items' || s === 'main-cart-footer';
    });
    var drawerSections = sectionsToFetch.filter(function (s) { return s === 'cart-drawer'; });

    var promises = [];
    if (cartPageSections.length) {
      promises.push(fetch('/cart?sections=' + cartPageSections.join(','), {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
      }).then(function (r) { return r.json(); }));
    } else { promises.push(Promise.resolve({})); }
    if (drawerSections.length) {
      promises.push(fetch(window.location.pathname + '?sections=' + drawerSections.join(','), {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
      }).then(function (r) { return r.json(); }));
    } else { promises.push(Promise.resolve({})); }

    Promise.all(promises).then(function (results) {
      var combined = Object.assign({}, results[0] || {}, results[1] || {});
      var swapped = 0;
      sectionsToFetch.forEach(function (sectionId) {
        if (!combined[sectionId]) return;
        var parser = new DOMParser();
        var newDoc = parser.parseFromString(combined[sectionId], 'text/html');
        var targetId = null;
        if (sectionId === 'cart-drawer') targetId = 'shopify-section-cart-drawer';
        if (sectionId === 'main-cart-items') targetId = 'shopify-section-main-cart-items';
        if (sectionId === 'main-cart-footer') targetId = 'shopify-section-main-cart-footer';
        var target = document.getElementById(targetId);
        var newSection = newDoc.getElementById(targetId);
        if (target && newSection) {
          target.innerHTML = newSection.innerHTML;
          swapped++;
        }
      });
      // If nothing was actually swapped on the cart page, the response was empty/wrong shape.
      // Hard reload as ultimate fallback so the user is never stuck on a stale empty state.
      if (swapped === 0 && (cartPageSections.length || drawerSections.length)) {
        window.location.reload();
        return;
      }
      // Bootstrap any custom JS that needs to re-bind to fresh DOM
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { data: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      }).catch(function () {});
    }).catch(function () {
      window.location.reload();
    });
  }

  function isShowingEmptyState() {
    // Cart page: <cart-items class="is-empty">  -or-  no rows inside #main-cart-items
    var ci = document.querySelector('cart-items');
    if (ci && ci.classList.contains('is-empty')) return true;
    var emptyBlock = document.querySelector('.luv-cart-empty');
    if (emptyBlock && emptyBlock.offsetParent !== null) return true;
    // Drawer: cart-drawer has .is-empty class when zero items
    var cd = document.querySelector('cart-drawer');
    if (cd && cd.classList.contains('is-empty')) return true;
    return false;
  }

  function refreshCartUI() {
    // v6 (2026-06-06): refresh only the cart line items + footer (price totals,
    // reward strip) via Section Rendering. Do NOT touch the cross-sell aside.
    // The clicked card stays mounted; setBtnState handles its own lifecycle.
    if (isShowingEmptyState()) {
      forceFullCartRerender();
      return;
    }
    // Dispatch cart events for sticky bar, rewards, candle picker, etc.
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.dispatchEvent(new CustomEvent('cart:update', { detail: { data: cart } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }).catch(function(){});
    // Refresh cart-page line items + footer via Section Rendering API. We swap
    // ONLY the inner line-item table and the cart-footer, leaving the xsell
    // aside (which lives outside those nodes) untouched.
    if (isCartPage()) {
      fetch('/cart?sections=main-cart-items,main-cart-footer', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
      }).then(function(r){return r.json();}).then(function(data){
        if (data && data['main-cart-items']) {
          var parser = new DOMParser();
          var newDoc = parser.parseFromString(data['main-cart-items'], 'text/html');
          // Replace only the <form id="cart"> contents (the actual line items),
          // NOT the entire shopify-section (which contains the xsell aside).
          var newForm = newDoc.querySelector('form#cart, form[action="/cart"]');
          var oldForm = document.querySelector('#main-cart-items form#cart, #main-cart-items form[action="/cart"]');
          if (newForm && oldForm) {
            oldForm.innerHTML = newForm.innerHTML;
          } else {
            // Fallback: replace just the cart-items custom element inner
            var newCI = newDoc.querySelector('cart-items');
            var oldCI = document.querySelector('#main-cart-items cart-items');
            if (newCI && oldCI) oldCI.innerHTML = newCI.innerHTML;
          }
        }
        if (data && data['main-cart-footer']) {
          var p2 = new DOMParser();
          var fDoc = p2.parseFromString(data['main-cart-footer'], 'text/html');
          var newFooter = fDoc.getElementById('shopify-section-main-cart-footer');
          var oldFooter = document.getElementById('shopify-section-main-cart-footer');
          if (newFooter && oldFooter) oldFooter.innerHTML = newFooter.innerHTML;
        }
      }).catch(function(){});
    }
  }

  function setBtnState(btn, state, label) {
    btn.classList.remove('is-loading', 'is-added', 'is-error');
    if (state) btn.classList.add('is-' + state);
    // v5 : support both old .luv-xsell__add-text (drawer) and new .luv-xsell__ctarow-label (page)
    var textEl = btn.querySelector('.luv-xsell__ctarow-label') || btn.querySelector('.luv-xsell__add-text');
    if (textEl && label) textEl.textContent = label;
  }

  function handleAdd(btn) {
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    var labelAdd    = btn.getAttribute('data-label-add')    || 'Add to ritual';
    var labelAdding = btn.getAttribute('data-label-adding') || 'Adding';
    var labelAdded  = btn.getAttribute('data-label-added')  || 'Added';
    setBtnState(btn, 'loading', labelAdding);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        setBtnState(btn, 'added', labelAdded);
        refreshCartUI();
        // v5 : do NOT remove the card. After a brief "Added" flash, reset to resting state.
        setTimeout(function () { setBtnState(btn, '', labelAdd); }, 1400);
      })
      .catch(function () {
        setBtnState(btn, 'error', 'Try again');
        setTimeout(function () { setBtnState(btn, '', labelAdd); }, 1500);
      });
  }

  function bind(root) {
    $$('[data-luv-xsell-add], [data-luv-ritual-add]', root).forEach(function (btn) {
      if (btn.__luvBound) return;
      btn.__luvBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        handleAdd(btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else { bind(document); }

  // Re-bind after cart re-renders
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { bind(document); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
